import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zeroonetobool'
})
export class ZeroonetoboolPipe implements PipeTransform {

  transform(value: string): boolean{
    //console.log(value);
    if(value == '1'){
      return true;
    }else if(value == '0'){
      return false;
    }
  }

}
